export class InvalidAppSchemeError extends Error {
  constructor(scheme: string) {
    super(scheme);
    this.name = 'InvalidAppSchemeError';
  }
}
